export const proparkStyles = {
	header: {
		backgroundColor: '#f2f2f2',
	},
	sidebar: {
		backgroundColor: '#0d4075',
		color: 'white',
	},
	button: {
		backgroundColor: '#faaf40',
		border: '4px solid #faaf40',
		borderWidth: '4px',
		borderRadius: '22px',
		fontWeight: 600,
		color: '#393839',
		':hover': {
			color: '#FFFFFF',
			backgroundColor: '#faaf40',
			borderColor: '#faaf40',
		},
	},
	title: {
		color: 'black',
	},
	outlinedButton: {
		border: '4px solid #faaf40',
		':hover': {
			border: '4px solid #faaf40',
		},
	},
	text: {
		color: '#393839',
	},
	table: {
		headerBackgroundColor: '#f2f2f2',
		headerTextColor: '#393839',
	},
	platformName: {
		name: 'Propark Parking Platform',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/propark/propark-logo-small.svg',
			height: 40,
			width: 40,
		},
		large: {
			src: '/propark/propark-logo-white.svg',
			height: 45,
			width: 125,
		},
	},
	favicon: {
		src: '/propark/propark-logo-small.svg',
	},
	socials: {
		instagram: 'https://instagram.com/propark_mobility',
		x: 'https://twitter.com/ProparkMobility',
		facebook: 'https://www.facebook.com/proparkmobility/',
		linkedIn: 'https://www.linkedin.com/company/proparkmobility/',
	},
	siteUrl: 'https://www.propark.com/',
	orgName: 'ProPark Mobility',
};
